export const categoryCompare = (program1, program2) => {
  if (!!program1.category && !!program2.category) {
    return program1.category.order - program2.category.order
  } else if (program1.category !== program2.category) {
    return 1
  }

  return 0
}
